import { Grid, GridColumn as Column, GridColumnMenuProps, GridColumnMenuCheckboxFilter, GridCellProps, GridToolbar, GridColumn, GridPageChangeEvent, GridColumnMenuFilter, cellOperatorChange, cellInputChange } from '@progress/kendo-react-grid';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useLocalization } from '@progress/kendo-react-intl';
import { AccessToken } from '../config/AccessToken';
import { Button } from '@progress/kendo-react-buttons';
import { useNavigate } from 'react-router-dom';
import { fileCsvIcon, fileExcelIcon, filePdfIcon, filterIcon, saveIcon, uploadIcon } from '@progress/kendo-svg-icons';
import { process as kendoProcess } from "@progress/kendo-data-query";
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { GridPDFExport } from '@progress/kendo-react-pdf';
import { Popup } from '@progress/kendo-react-popup';
import { CSVLink } from 'react-csv';
import { json2csv } from 'json-2-csv';
import { loadingPanel } from '../components/LoadingPanel';
import { HeaderThElement, PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { ConfiguratorToggleColumnsGrid } from '../components/ConfiguratorToggleColumnsGrid';
import { SvgIcon } from '@progress/kendo-react-common';
import { filter } from '@progress/kendo-data-query/dist/npm/transducers';
import { DatePicker, TimePicker } from '@progress/kendo-react-dateinputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';

/**
 * A cell component that displays a button to navigate to the map
 * view for the associated beacon.
 *
 * When clicked, it saves the beacon's id and map id in local storage
 * and navigates to the map view.
 *
 * @param {Object} props - The properties passed to the component.
 */
const LinkMapCell = (props: any) => {

  const localizationService = useLocalization();

  const navigate = useNavigate()
  const showMap = () => {
    let beaconId = props?.dataItem?.id;
    let beaconMapId = props?.dataItem?.mapId;
    if (beaconId != null) {
      localStorage.setItem("beaconId", beaconId);
    }
    if (beaconMapId != null) {
      localStorage.setItem("beaconMapId", beaconMapId);
    }
    navigate("/home/map")
  }

  return (
    <td className="k-command-cell">
      <button
        id='map'
        className="k-icon k-font-icon k-i-globe"
        style={{ color: '#198792', margin: '8px', border: 'none', background: 'none', outline: 'none' }}
        onClick={() => showMap()}
      >
        <a
          id='map'
          title={localizationService.toLanguageString('beacons.map', 'NOT_FOUND')}
        />
        {/*<td className="k-icon k-font-icon k-i-globe" style={{ paddingBlock: '0.5rem', cursor: 'pointer' }} ></td>*/}
      </button>
    </td>
  );
};

interface PageState {
  skip: number;
  take: number;
}

//const initialDataState: PageState = { skip: 1, take: 10 };
const initialDataState: PageState = { skip: 0, take: 10 };

/**
 * The `Beacons` component is responsible for displaying and managing a grid of
 * beacon devices. It retrieves beacon data from a server, displays it in a grid,
 * and provides functionalities such as filtering, sorting, exporting to Excel and PDF,
 * and state persistence in local storage.
 *
 * The grid supports column configuration, allowing users to toggle visibility,
 * reorder, and resize columns. It also highlights search text within the grid cells
 * and provides a command cell for navigation to a map view.
 *
 * The component manages both online and offline beacon data, displaying battery
 * status with color coding. It uses localization services for translating column titles
 * and other UI elements.
 *
 * Beacons data is fetched using an API call, and the component handles loading and error
 * states during this process. The component's state is initialized and updated using
 * React hooks.
 *
 * @returns {JSX.Element} The JSX code for rendering the Beacons grid component.
 */
export const Beacons = () => {

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  const ADJUST_PADDING: number = 18;
  const COLUMN_MIN: number = 4;
  const minGridWidth = useRef<number>(0);
  const [applyMinWidth, setApplyMinWidth] = useState(false);
  const [gridCurrent, setGridCurrent] = useState(0);

  
  const [processedData, setProcessedData] = useState<any>([])

  const [columns, setColumns] = useState<any>([])

  const [beacons, setBeacons] = useState<any>([]);
  const [beaconsOn, setBeaconsOn] = useState<any>([]);
  const [countBeaconsOn, setCountBeaconsOn] = useState(0);
  const [beaconsOff, setBeaconsOff] = useState([]);
  const [error, setError] = useState('');


  const [pageIndex, setPageIndex] = useState<any>(initialDataState);
  const [totalItems, setTotalItems] = useState<number>();

  const [dateValue, setDateValue] = useState<Date | null>(new Date());

  const [filterName, setFilterName] = useState<any>(() => {
    const filterNameBeacon = localStorage.getItem('filterNameBeacon');
    return filterNameBeacon ? JSON.parse(filterNameBeacon) : [];
  });

  const [loading, setLoading] = useState(false);

  const localizationService = useLocalization();

  const [instance, accessTokenRequest] = AccessToken();

  const userEmail = localStorage.getItem('email');

  const formatDate = (date: any) => {
    if(date != undefined){
      // Split the date and time
      const [day, month, year] = date?.split(" ")[0]?.split("/"); 

      let dateParts = date?.split(" ");
      const timeValues:any = dateParts[1]?.split(":");
      
      let hour = parseInt(timeValues[0], 10);
      let minute = parseInt(timeValues[1], 10);
      let second = parseInt(timeValues[2], 10);
      
      // Convert the string to a Date object
      let dateConvert = new Date(Date.UTC(year, month-1, day, hour, minute, second))
      
      // Convert the date to the user's local timezone
      let localDate = dateConvert?.toLocaleString(navigator.language).replace(/,/g, '')
      
      const timeConvert = localDate?.split(" ")[1];
      const timeValuesConvert:any = timeConvert?.split(":");
      const formattedHours = String(timeValuesConvert[0]).padStart(2, '0'); // Add leading zero if needed
      const formattedMinutes = String(timeValuesConvert[1]).padStart(2, '0');
      const formattedSeconds = String(timeValuesConvert[2]).padStart(2, '0');
      const formattedTime = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
      
      if(navigator.language == 'en' || navigator.language == 'en-US' || navigator.language == 'en-GB'){
        const [monthConvert, dayConvert, yearConvert] = localDate?.split(" ")[0].split("/"); 
        const formattedMonth = String(monthConvert).padStart(2, '0'); // Add leading zero if needed
        const formattedDay = String(dayConvert).padStart(2, '0');
        const validDate = `${yearConvert}-${formattedMonth}-${formattedDay}T${formattedTime}`;
        return new Date(validDate);
      }
      else{
        const [dayConvert, monthConvert, yearConvert] = localDate?.split(" ")[0].split("/"); 
        const formattedMonth = String(monthConvert).padStart(2, '0'); // Add leading zero if needed
        const formattedDay = String(dayConvert).padStart(2, '0');
        const validDate = `${yearConvert}-${formattedMonth}-${formattedDay}T${timeConvert}`;
        return new Date(validDate);
      }
    }else{
      return 0
    }
  }

  const getBeaconPaginatedList = async (flag: boolean, skip?: any, take?: any) => {

    let languageId = localStorage.getItem('languageId');
    setLoading(true)

    const commonOperations = async (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      const params = {
        enabled: flag,
        pageIndex: skip ?? pageIndex?.skip,
        pageSize: take ?? pageIndex?.take
      };
      try {
        const res:any = await axios.get(`${SERVER_URL}/beacon/paginatedlist`, { headers, params })
        
        const data:any = res.data.data
        
        if(data.items.length == 0) return;

        let beaconOn: any = [] 
       
        if (flag) {
          setCountBeaconsOn(data?.length)
          // format date in data.data
          data?.items?.forEach((beacon: any) => {
            if (beacon?.lastSeen == null) {
              beacon.lastSeen = localizationService.toLanguageString('beacons.date_not_found', 'NOT_FOUND')
              return
            }
            beacon.lastSeen = formatDate(beacon?.lastSeen)
            beaconOn.push(beacon)
          })
          
          setBeaconsOn(beaconOn);
          setBeacons(data?.totalItems)

          setTotalItems(data?.totalItems)

          const currColumns: any = [
            { field: 'id', title: "Id", columnMenu: ColumnMenuCheckboxFilter, editable: false, show: true },
            { field: 'name', title: localizationService.toLanguageString('beacons.name', 'NOT_FOUND'), columnMenu: ColumnMenuCheckboxFilter, filterable: true, editable: false, show: true },
            { field: 'type', title: localizationService.toLanguageString('beacons.type', 'NOT_FOUND'), columnMenu: ColumnMenuCheckboxFilter, filterable: true, editable: false, show: true },
            { field: 'lastSeen', title: localizationService.toLanguageString('beacons.last_seen', 'NOT_FOUND'), filter: 'date', format: '{0:dd/MM/yyyy HH:mm:ss}', filterable: true, editable: false, show: true },
            { field: 'battery', title: localizationService.toLanguageString('beacons.battery', 'NOT_FOUND'), filter: 'numeric', cell: CellBatteryComponent, filterable: true, editable: false, show: true }
          ];

          setColumns(currColumns);

          loadStateFromLocalStorage()

        } else {
          setBeaconsOff(data.items);
        }
        setLoading(false)
      } catch (error: any) {
        setError(error);
        setLoading(false)
      }
    }
    if (sessionStorage.getItem('accessToken') != null) {
      let accessToken = sessionStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
        // Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken)
      })
    }
  }

  useEffect(() => {
    getBeaconPaginatedList(true)
  }, [])

  const exportRecords = async (format:any) => {

    setLoading(true);

    let languageId = localStorage.getItem('languageId');

    const commonOperations = (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      
      axios.get(`${SERVER_URL}/beacon/download?format=${format}`, { headers, responseType: 'blob' })
        .then((response) => {

          const type:any = format == 'csv' ? 'text/csv;charset=utf-8;' : format == 'excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/pdf'
          
          const ext:any = format == 'csv' ? '.csv' : format == 'excel' ? '.xlsx' : '.pdf'

          const blob = new Blob([response.data], { type: type });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.setAttribute("href", url);
          link.setAttribute("download", `records${ext}`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          setLoading(false);

        }).catch((error) => {
          if (error.response) {
            setError(error.response.data.message);
          } else {
            setError(error.message);
          }
          setLoading(false);
        });
    }

    if (sessionStorage.getItem('accessToken') != null) {
      let accessToken = sessionStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
        // Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
    }
  }

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent: any = event?.targetEvent as PagerTargetEvent;
    const take: any = targetEvent?.value === "All" ? totalItems : event?.page?.take;

    setPageIndex({
      ...event?.page,
      take,
    });

    getBeaconPaginatedList(true, (event?.page?.skip / take) + 1, take)
  };

  const removeFilterByField = (filterObject: any, fieldName: any): any => {
    if (!filterObject || !filterObject.filters || !Array.isArray(filterObject.filters)) {
      return { logic: 'and', filters: [] };
    }
    
    const updatedFilters = filterObject.filters
    .map((item: any) => {
      // Se è il filtro da rimuovere
      if (item.field === fieldName) {
        return null;
            }
            
            // Se è un gruppo di filtri annidato
            if (item.filters && Array.isArray(item.filters)) {
              const updatedGroup = removeFilterByField(item, fieldName);
                // Mantieni solo se il gruppo ha ancora filtri
                if (updatedGroup.filters.length > 0) {
                    return updatedGroup;
                  } else {
                    return null;
                  }
                }
            return item;
        })
        .filter((item: any) => item !== null);

        // Sempre restituire un oggetto con 'logic' e 'filters'
        return {
          logic: filterObject.logic || 'and',
          filters: updatedFilters
    };
  };

  const ColumnMenu = (props: any) => {

    const {
      firstFilterProps,
      hideSecondFilter,
      secondFilterProps,
      logicData,
      logicValue,
      onLogicChange,
    } = props;

    const customFilterOperators:any = {
      date: [
        { text: 'grid.filterNotEqOperator', operator: 'neq' },
        { text: 'grid.filterAfterOrEqualOperator', operator: 'gte' },
        { text: 'grid.filterAfterOperator', operator: 'gt' },
        { text: 'grid.filterBeforeOperator', operator: 'lt' },
        { text: 'grid.filterBeforeOrEqualOperator', operator: 'lte' },
        //{ text: 'grid.filterIsNullOperator', operator: 'isnull' },
        //{ text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' }
      ]
    };

    const handleFilterChange = (filterValue: any) => {          
      setDataState((prevState: any) => ({
        ...prevState,
        filter: filterValue
      }));
      let filterName:any=[]
      filterValue?.filters?.forEach((filter:any) => {
        filter?.filters?.forEach((filterInfo:any) => {
          filterName.push(filterInfo.field)
        })
      })
      setFilterName(filterName)
      localStorage.setItem("filterNameBeacon", JSON.stringify(filterName));
    };

    return (
      <div>
        <GridColumnMenuFilterCell 
          {...firstFilterProps} 
          alwaysExpand
          //filterOperators={customFilterOperators}
          onFilterChange={handleFilterChange}          
        />
      </div>
    );
  }

  const ColumnMenuCheckboxFilter = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuCheckboxFilter {...props} data={beaconsOn} expanded={true} searchBoxFilterOperator={'contains'}/>
      </div>
    );
  }

  const ColumnMenuNumericFilter = (props: any) => {

    useEffect(() => {
      // Questo effetto scatta all'apertura del filtro
      localStorage.setItem('filterOpenedColumn', 'openedColumn');
    }, []);

    useEffect(() => {  
      // Delegazione click su bottone reset
      const handleDocumentClick = (e: MouseEvent) => {
        const button = (e.target as HTMLElement).closest('button[type="reset"]');
        if (button) {
          handleResetClick();
        }
      };
  
      document.body.addEventListener('click', handleDocumentClick);
      return () => document.body.removeEventListener('click', handleDocumentClick);
    }, []);

    const handleResetClick = () => {
      const field = props.column.field;
  
      // Rimuove il filtro solo per la colonna corrente
      const currentFilter = dataState.filter;
      if (!currentFilter || !Array.isArray(currentFilter.filters)) return;
  
      // Applichiamo la rimozione ricorsiva
      const updatedFilterObject = removeFilterByField(currentFilter, field);
  
      const newState = {
        ...dataState,
        filter: {
          logic: 'and',
          filters: updatedFilterObject.filters
        }
      };
  
      setDataState(newState);
      setFilterName((prev: any) => prev.filter((item: any) => item !== field));
      localStorage.setItem(`gridBeaconState: ${userEmail}`, JSON.stringify({ dataState: newState, columns }));
      localStorage.removeItem('filterOpenedColumn');
    };

    if (!props || !props.column) {
      return null;
    }
    
    const customFilterOperators:any = {
      numeric: [
          { text: 'grid.filterEqOperator', operator: 'eq' },
          { text: 'grid.filterNotEqOperator', operator: 'neq' },
          { text: 'grid.filterGteOperator', operator: 'gte' },
          { text: 'grid.filterGtOperator', operator: 'gt' },
          { text: 'grid.filterLteOperator', operator: 'lte' },
          { text: 'grid.filterLtOperator', operator: 'lt' }
     
      ]
    };

    const handleFilterChange = (filterValue: any) => {

      const filterName = props.column.field;      
      
      // Ricorsivamente verifica se il filtro contiene il campo
      const containsFilterField = (filter: any): boolean => {
        if (!filter) return false;

        if (Array.isArray(filter.filters)) {
          return filter.filters.some((f:any) => containsFilterField(f));
        }

        return filter.field === filterName;
      };

      const shouldRemove = !filterValue || !containsFilterField(filterValue);

      if (shouldRemove) {
        setFilterName((prevFilterName: any) =>
          prevFilterName.filter((item: any) => item !== filterName)
        );
        localStorage.removeItem('filterOpenedColumn');
        return;
      }else {
        setFilterName((prevFilterName: any) =>
          prevFilterName.includes(filterName)
            ? prevFilterName
            : [...prevFilterName, filterName]
        );
  
        const newFilter: any = filterValue;
        setDataState((prevState: any) => ({
          ...prevState,
          filter: newFilter
        }));
  
        // Salvataggio immediato dello stato nel localStorage
        const newState = {
          dataState: {
            ...dataState,
            filter: newFilter
          },
          columns
        };
        localStorage.setItem(`gridBeaconState: ${userEmail}`, JSON.stringify(newState));        
      }
    };

    return (
      <GridColumnMenuFilter
        {...props}
        expanded={true} 
        hideSecondFilter={true}
        filterOperators={customFilterOperators}
        onFilterChange={handleFilterChange}  
        //onCloseMenu={() => {
        //  const filterName = props.column.field;      
        //  setFilterName((prevFilterName:any) => {
        //    return prevFilterName.filter((item:any) => item !== filterName);
        //  });
        //  localStorage.removeItem('filterOpenedColumn');
        //}}
      />
    );
  };

  const CellBatteryComponent = (props: GridCellProps) => {
    const batteryValue = props.dataItem.battery;
    if (batteryValue < 20) {
      return(
        <td>
          <svg className="battery-svg" viewBox="0 0 50 20">
            <rect className="battery-outline" x="1" y="1" width="40" height="18" rx="3" ry="3" fill="red" stroke="#333" stroke-width="1"/>
            <rect className="battery-nub" x="43" y="6" width="6" height="8" rx="2" ry="2" fill="red" stroke="#333"/>
            <text
              x="21"  y="12"  dominant-baseline="middle" text-anchor="middle"
              font-size="10"
              fill="white"
            >
              {batteryValue}% 
            </text>
          </svg>          
        </td>
      )
    }
    else if (batteryValue >= 20 && batteryValue <= 83) {
      return(
        <td>
          <svg className="battery-svg" viewBox="0 0 50 20">
            <rect className="battery-outline" x="1" y="1" width="40" height="18" rx="3" ry="3" fill="orange" stroke="#333" stroke-width="1"/>
            <rect className="battery-nub" x="43" y="6" width="6" height="8" rx="2" ry="2" fill="orange" stroke="#333"/>
            <text
              x="21"  y="12"  dominant-baseline="middle" text-anchor="middle"
              font-size="10"
              fill="white"
            >
              {batteryValue}% 
            </text>
          </svg>          
        </td>
      )
    } else {
      return(
        <td>
          <svg className="battery-svg" viewBox="0 0 50 20">
            <rect className="battery-outline" x="1" y="1" width="40" height="18" rx="3" ry="3" fill="green" stroke="#333" stroke-width="1"/>
            <rect className="battery-nub" x="43" y="6" width="6" height="8" rx="2" ry="2" fill="green" stroke="#333"/>
            <text
              x="21"  y="12"  dominant-baseline="middle" text-anchor="middle"
              font-size="10"
              fill="white"
            >
              {batteryValue}% 
            </text>
          </svg>
        </td>
      )
    }  
  };

  const [dataState, setDataState] = useState<any>({
    skip: 0,
    take: pageIndex?.take ?? 10,
    data: beacons,
    total: beacons?.length,
    filter: { logic: 'and', filters: [] },
    sort: [{ field: 'id', dir: 'desc' }]
  });
  //const [columns, setColumns] = useState(() => {
  //  const currColumns: any = [
  //    { field: 'id', title: "Id", columnMenu: ColumnMenuCheckboxFilter, editable: false, show: true },
  //    { field: 'name', title: localizationService.toLanguageString('beacons.name', 'NOT_FOUND'), columnMenu: ColumnMenuCheckboxFilter, filterable: true, editable: false, show: true },
  //    { field: 'type', title: localizationService.toLanguageString('beacons.type', 'NOT_FOUND'), columnMenu: ColumnMenuCheckboxFilter, filterable: true, editable: false, show: true },
  //    { field: 'lastSeen', title: localizationService.toLanguageString('beacons.last_seen', 'NOT_FOUND'), filter: 'date', format: '{0:dd/MM/yyyy}', filterable: true, editable: false, show: true },
  //    { field: 'battery', title: localizationService.toLanguageString('beacons.battery', 'NOT_FOUND'), columnMenu: ColumnMenuCheckboxFilter, cell: CellBatteryComponent, filterable: true, editable: false, show: true }
  //  ];
  //  setCurrentColumn(currColumns);

  //  const savedState = localStorage.getItem(`gridBeaconState: ${userEmail}`);

  //  return savedState
  //    ? JSON.parse(savedState)
  //    : currColumns;
  //});

  const saveStateToLocalStorage = () => {
    const state: any = { dataState, columns };
    localStorage.setItem(`gridBeaconState: ${userEmail}`, JSON.stringify(state));
  };

  const loadStateFromLocalStorage = () => {
    const storedFilter = localStorage.getItem(`gridBeaconState: ${userEmail}`);
    if (storedFilter) {
      const { dataState: savedDataState, columns: savedColumns } = JSON.parse(storedFilter);
      
      if (savedDataState?.filter != null) {
        // Funzione ricorsiva per gestire qualsiasi struttura di filtri
        const updateFilterValues = (filter: any): any => {
          if (Array.isArray(filter.filters)) {
            return {
              ...filter,
              filters: filter.filters.map(updateFilterValues),
            };
          } else {
            const field = filter?.field;
            let value = filter?.value;
  
            if (['lastSeen'].includes(field)) {
              value = new Date(value);
            }
  
            return {
              ...filter,
              value,
            };
          }
        };
  
        const updatedFilter = updateFilterValues(savedDataState.filter);
  
        const updatedSavedDataState = {
          ...savedDataState,
          filter: updatedFilter,
        };
  
        setDataState(updatedSavedDataState);
      } else {
        setDataState(savedDataState);
      }

      let currentColumn:any = savedColumns?.map((column: any, id: any) => {
        if(column.id == id){
          return { ...column, show: !column.show }; // Create a *new* object
        }
        return column; // Return the other columns unchanged
      });

      return storedFilter
        ? storedFilter
        : currentColumn;
    }
  };

  const anchor = useRef<any>(null);
  const [showPopupSaveConfig, setShowPopupSaveConfig] = useState(false);

  const onClickSaveConfig = () => {
    setShowPopupSaveConfig(!showPopupSaveConfig);

    setTimeout(() => {
      setShowPopupSaveConfig(showPopupSaveConfig);
    }, 3000)

  };

  const onChange = (event: any) => {
    const field = event.target.name;
    const newColumns = columns.map((column: any) => {
      if (column.field === field) {
        return { ...column, show: !column.show };
      }
      return column;
    });
    setColumns(newColumns);
    
    const state = { dataState, columns: newColumns };
    localStorage.setItem(`gridBeaconState: ${userEmail}`, JSON.stringify(state));
  };

  const onColumnReorder = (event: any) => {
    setColumns(event.columns);
    saveStateToLocalStorage();
  };

  const onColumnResize = (event: any) => {
    setColumns(event.columns);
    saveStateToLocalStorage();
  };

  const onDataStateChange = (event: any) => {
    
    const newFilter: any = event.dataState.filter
      ? { ...event.dataState.filter }
      : { logic: 'and', filters: [] };

    setDataState((prevState: any) => ({
      ...prevState,
      filter: newFilter
    }));

    let filterName:any=[]
    newFilter?.filters?.forEach((filter:any) => {
      filter?.filters?.forEach((filterInfo:any) => {
        filterName.push(filterInfo.field)
      })
    })
    setFilterName(filterName)
    localStorage.setItem("filterNameBeacon", JSON.stringify(filterName));

    const { dataState } = event;
    if (dataState) {
      const { filter, sort, skip, take } = dataState;
      const updatedFilter = filter || dataState.filter;
      const updatedSkip = skip !== undefined ? skip : dataState.skip;
      const updatedTake = take !== undefined ? take : dataState.take;
      setDataState((prevState: any) => ({
        ...prevState,
        filter: updatedFilter,
        sort: sort,
        skip: updatedSkip,
        take: updatedTake
      }));
    }
    
    const state = { dataState, columns };
    localStorage.setItem(`gridBeaconState: ${userEmail}`, JSON.stringify(state));
  };

  const CellRender = (props: any) => {
    return (
      <td
          {...props.tdProps}
          colSpan={1}
      >
          {props.children}
      </td>
    );
  }

  useEffect(() => {
    const result = kendoProcess(beaconsOn ?? [], {
        filter: dataState?.filter,
        sort: dataState?.sort,
        skip: dataState?.skip,
        take: pageIndex?.take ?? dataState?.take,
    });

    setProcessedData(result.data);
    if(filterName.length != 0){
      setTotalItems(result.total);
    }else{
      setTotalItems(beacons);
    }

  }, [beaconsOn,filterName]);

  const formatDateFromIsoToString = (isoString:any) => {
    const date = new Date(isoString);
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
  
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  const DateTimeCellWithBackGroundComponent = (props: any) => {
    const dateTimeValue:any = formatDateFromIsoToString(props?.dataItem?.lastSeen);  
    if(dateTimeValue != null && !dateTimeValue.includes('1970')){   
      return(
        <td>
          <span className='k-table-row k-master-row date-time'>{dateTimeValue}</span>
        </td>
      )
    } else {
      return(
        <td><span className='k-table-row k-master-row date-time' /></td>
      )
    }
  };

  const GridColumnMenuFilterCell = (props:any) => {
      const gridColumnMenuFilterCell = useRef<any>(null);
  
      useEffect(() => {
        
        const handleDocumentClick = (e: MouseEvent) => {
          const button = (e.target as HTMLElement).closest('button[type="reset"]');
          if (button) {
            handleResetClick();
          }
        };
    
        document.body.addEventListener('click', handleDocumentClick);
        return () => document.body.removeEventListener('click', handleDocumentClick);
      }, []);
  
      const handleResetClick = () => {
        const field = props.field;
    
        // Rimuove il filtro solo per la colonna corrente
        const currentFilter = dataState.filter;
        if (!currentFilter || !Array.isArray(currentFilter.filters)) return;
    
        // Applichiamo la rimozione ricorsiva
        const updatedFilterObject = removeFilterByField(currentFilter, field);
  
        const newState = {
          ...dataState,
          filter: {
            logic: 'and',
            filters: updatedFilterObject.filters
          }
        };
    
        setDataState(newState);
        setFilterName((prev: any) => prev.filter((item: any) => item !== field));
        localStorage.setItem(`gridBeaconState: ${userEmail}`, JSON.stringify({ dataState: newState, columns }));
        localStorage.removeItem('filterOpenedColumn');
      };
  
      useEffect(() => {
        // Questo effetto scatta all'apertura del filtro
        localStorage.setItem('filterOpenedColumn', 'openedColumn');
      }, []);
  
      const [selectedOperator, setSelectedOperator] = useState(props.operator || 'eq');    
  
      const addFilter = (obj: any, filtro: any, logic = "or") => {
        // Trova il prossimo indice disponibile
        let keys = Object.keys(obj).map(k => parseInt(k));
        let nextIndex = keys.length > 0 ? Math.max(...keys) + 1 : 0;
    
        // Aggiungi il nuovo filtro
        obj[nextIndex.toString()] = {
            "logic": logic,
            "filters": [filtro]
        };
    
        return obj;
      }
  
      const containsDateTimeField = (filters:any):boolean => {
        if (!Array.isArray(filters)) return false;
    
        return filters.some((filter:any) => {
            if (filter.field === 'lastSeen') {
                return true;
            } 
            // Se ha sotto-filtri, ricorsivamente cerca anche lì
            if (Array.isArray(filter.filters)) {
                return containsDateTimeField(filter.filters);
            }
            return false;
        });
      };
  
      const replaceOrNestDateTimeFilterAtTop = (filters: any[], newFilter: any): any[] => {
        let found = false;
    
        // Ricorsivamente sostituisce
        const recursiveReplace = (filtersArray: any[]): any[] => {
            return filtersArray.map((f: any) => {
                if (f.filters && Array.isArray(f.filters)) {
                    return { ...f, filters: recursiveReplace(f.filters) };
                } else if (f.field === 'lastSeen') {
                    found = true;
                    return newFilter;
                }
                return f;
            });
        };
    
        let updatedFilters = recursiveReplace(filters);
    
        if (!found) {
            // Se non trovato, crea un nuovo gruppo 'or' con dateTime
            const dateTimeGroup = {
                logic: 'or',
                filters: [newFilter]
            };
    
            // Inserisci il gruppo dateTime sempre in posizione 0
            //updatedFilters = [dateTimeGroup, ...updatedFilters];
            addFilter(updatedFilters, dateTimeGroup, 'or');
        } 
        return updatedFilters;
      };
    
  
      const inputChange = (value:any, e:any) => {
        cellInputChange(value, e, props);
  
        setDateValue(value)
  
        if (value == null) {
          return;
        } 
  
        value.setUTCMilliseconds(0);
        value = value.toISOString()
  
        const filterObj = {   
          ...dataState?.filter
        };
  
        const newFilter = {
          "field": props.field,
          "operator": selectedOperator,
          "value": value
        };
  
        if(filterObj?.filters == undefined){
          filterObj.logic = 'and';
          filterObj.filters = [{                              
            logic: "or",
            filters:[ newFilter ]
          }]
        }else{
          if(containsDateTimeField(filterObj.filters)){
            filterObj.filters = replaceOrNestDateTimeFilterAtTop(filterObj.filters, newFilter);
          }else{
            addFilter(filterObj.filters, newFilter, 'or');
          }
        }
          
        setDataState((prevState: any) => ({
          ...prevState,
          filter: filterObj
        }));
  
        // Set filter name for tracking
        const filterName = props.field;
        
        setFilterName((prevFilterName:any) => {
          return [...prevFilterName, filterName];
        });
        
        // Salva subito lo stato aggiornato
        const newState = {
          dataState: {
            ...dataState,
            filter: filterObj
          },
          columns
        };
        localStorage.setItem(`gridBeaconState: ${userEmail}`, JSON.stringify(newState));
  
        getBeaconPaginatedList(true);
  
      };    
    
      const operatorChange = (event:any) => {
        const newOperator = event.value.operator;
        setSelectedOperator(newOperator); // <-- Track selected operator
        cellOperatorChange(event, props.value, props.onChange);
      };
    
      const renderOperatorEditor = () => {
        const { operators } = props;
  
        const filteredOperators = operators.filter(
          (op: any) => op.operator !== 'isnull' && op.operator !== 'isnotnull'
        );
    
        const value = filteredOperators.find((item: any) => item.operator === selectedOperator) || null;
    
        return (
          <DropDownList
            value={value}
            onChange={operatorChange}
            data={filteredOperators}
            textField="text"
          />
        );
      };
    
      return (
        <div onClick={(e) => e.stopPropagation()}>
          {renderOperatorEditor()}
  
          <DatePicker    
            popupSettings={{ appendTo: document.body }}
            ref={gridColumnMenuFilterCell}      
            value={dateValue}
            format="dd/MM/yyyy"
            formatPlaceholder={'formatPattern'}
            onChange={(e:any) => inputChange(e.value, e.syntheticEvent)}
            onClick={(e) => e.stopPropagation()}
          />
          
          <div style={{marginBottom: '10px'}}></div>
  
          <TimePicker
            value={dateValue}
            format="HH:mm:ss" // Include seconds in the format
            formatPlaceholder={'formatPattern'}
            onChange={(e) => inputChange(e.value, e.syntheticEvent)}
          />
        </div>
      );
  };

  const CustomGridFilterDateTime = (props:any) => {
    const {
      firstFilterProps
    } = props;

     
    return (
      <div>
        <GridColumnMenuFilterCell           
          {...firstFilterProps} 
        />
      </div>
    );
  };

  const _excelExport = useRef<ExcelExport | null>(null);
  const excelExport = () => {
    if (_excelExport.current !== null) {
      _excelExport.current.save();
    }
  };

  const _pdfExport = useRef<GridPDFExport | null>(null);
  const pdfExport = () => {
    if (_pdfExport.current) {
      if (beaconsOn.length < 500) {
        _pdfExport.current.save(beaconsOn);
      } else {
        _pdfExport.current.save();
      }
    }
  };

  const IconHeaderCell = (props: any) => {

    localStorage.setItem('filterNameBeacon', JSON.stringify(filterName));
    
    localStorage.removeItem('filterOpenedColumn');
    const savedFilterName:any = localStorage.getItem('filterNameBeacon');
    
    return savedFilterName?.includes(props.field) ?       
      <HeaderThElement columnId={props.thProps?.columnId || ''} {...props.thProps} >
        <span style={{display:'inline-flex'}}>{props.children} <SvgIcon icon={filterIcon} size="medium"/></span>
      </HeaderThElement>    
    :
      <HeaderThElement columnId={props.thProps?.columnId || ''} {...props.thProps} >
        {props.children}
      </HeaderThElement>
  };

  return (
    <div 
      style={{ 
        display: 'grid',
        width: '98%',
        margin: '10px',        
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 15px 5px'        
      }}
    >
      {error && <p className="text-danger" style={{ zIndex: 999, position: 'relative', width: '65%' }}>{error}</p>}
      {/*{beaconsOn == null && loadingPanel}*/}
      {loading && loadingPanel}
        <ExcelExport data={beaconsOn} ref={_excelExport}>
          <Grid
            data={processedData}
            dataItemKey={"id"}
            cells={{ data: CellRender}}
            defaultTake={10}
            defaultSkip={0}
            total={totalItems}
            sortable={true}            
            reorderable={false}
            pageable={{ type: 'input', buttonCount: 5, pageSizes: [5, 10, 50, 100, 'All'], info: true }}
            sort={dataState.sort}
            filter={dataState.filter}
            onPageChange={pageChange}
            //onFilterChange={onFilterChange}
            onColumnReorder={onColumnReorder}
            onColumnResize={onColumnResize}
            onDataStateChange={onDataStateChange}
            scrollable= {'none'}
          >
            <GridToolbar>
              <div>
                <h3>{localizationService.toLanguageString('beacons.title', 'NOT_FOUND')}</h3>
              </div>
              <Popup
                anchor={anchor.current && anchor.current.element}
                show={showPopupSaveConfig}
                popupClass={"popup-content-save-synoptic-config"}
              >
                {localizationService.toLanguageString('synoptic_devices.saved_config', 'NOT_FOUND')}
              </Popup>
              <div style={{ right: '15px', float: 'right', position: 'absolute', display: 'flex', gap: '8px' }}>
                <ConfiguratorToggleColumnsGrid columns={columns} onChange={onChange} />
                
                <div>
                  <Button
                    themeColor={"primary"}
                    size="small"
                    title={localizationService.toLanguageString('export_to_csv', 'NOT_FOUND')}
                    svgIcon={fileCsvIcon}
                    onClick={()=>exportRecords('csv')}
                  />
                </div>
                <div>
                  <Button
                    onClick={()=>exportRecords('pdf')}
                    themeColor={"primary"}
                    size="small"
                    title={localizationService.toLanguageString('export_to_pdf', 'NOT_FOUND')}
                    svgIcon={filePdfIcon}
                  />
                </div>
                <div>
                  <Button
                    title={localizationService.toLanguageString('export_to_excel', 'NOT_FOUND')}
                    themeColor={"primary"}
                    size="small"
                    svgIcon={fileExcelIcon}
                    onClick={()=>exportRecords('excel')}
                  />
                </div>

                {/*<div>
                  <CSVLink data={json2csv(beacons)} separator={","}>
                    <Button
                      themeColor={"primary"}
                      size="small"
                      title={localizationService.toLanguageString('export_to_csv', 'NOT_FOUND')}
                      svgIcon={fileCsvIcon}
                    />
                  </CSVLink>
                </div>
                <div>
                  <Button
                    onClick={pdfExport}
                    themeColor={"primary"}
                    size="small"
                    title={localizationService.toLanguageString('export_to_pdf', 'NOT_FOUND')}
                    svgIcon={filePdfIcon}
                  />
                </div>
                <div>
                  <Button
                    title={localizationService.toLanguageString('export_to_excel', 'NOT_FOUND')}
                    themeColor={"primary"}
                    size="small"
                    svgIcon={fileExcelIcon}
                    onClick={excelExport}
                  />
                </div>*/}
                
                <div>
                  <Button
                    ref={anchor}
                    title={localizationService.toLanguageString('save_config', 'NOT_FOUND')}
                    themeColor={'primary'}
                    size="small"
                    svgIcon={saveIcon}
                    onClick={() => {
                      saveStateToLocalStorage();
                      onClickSaveConfig()
                    }}
                  >
                  </Button>
                </div>
                <div>
                  <Button
                    themeColor={'primary'}
                    size="small"
                    svgIcon={uploadIcon}
                    onClick={loadStateFromLocalStorage}
                    title={localizationService.toLanguageString('load_config', 'NOT_FOUND')}
                  >
                  </Button>
                </div>
              </div>
            </GridToolbar>
            <Column
              cells={{data: (props) => <LinkMapCell {...props} />}}
              width={50}
              editable={false}
              filterable={false}
              sortable={false}
            />
            {
              columns?.length > 0 ?
                columns?.map((column: any, index: any) =>
                  column?.show && (
                    column.field == 'lastSeen' ?
                      <Column              
                        field='lastSeen'
                        title={localizationService.toLanguageString('beacons.last_seen', 'NOT_FOUND')}
                        editable={false}
                        filterable={true}                        
                        filter={'date'}
                        format={column.format}
                        sortable={true}
                        columnMenu={(props) => (
                          <GridColumnMenuFilter
                            {...props}                        
                            alwaysExpand
                            filterUI={CustomGridFilterDateTime}
                            onExpandChange={() => {}}
                            onCloseMenu={() => {
                              const filterName = props.column.field;      
                              setFilterName((prevFilterName:any) => {
                                return prevFilterName.filter((item:any) => item !== filterName);
                              });
                              localStorage.removeItem('filterOpenedColumn');
                            }}
                          />
                        )}
                        cells={{ 
                          data: (props) => <DateTimeCellWithBackGroundComponent  {...props} />,
                          headerCell:IconHeaderCell 
                        }}
                      />
                      :
                      column.field == 'battery' ?
                        <Column              
                          field='battery'
                          title={localizationService.toLanguageString('beacons.battery', 'NOT_FOUND')}
                          editable={false}
                          filterable={true}
                          columnMenu={ColumnMenuNumericFilter}
                          className='k-text-center'
                          filter={column?.filter}
                          format={column?.format}
                          sortable={true}
                          cells={{
                              data: CellBatteryComponent,
                              headerCell:IconHeaderCell
                          }}
                        />
                      :
                      <Column
                        key={index}
                        field={column.field}
                        title={column.title}
                        filterable={column?.filterable}
                        columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                        className='k-text-center'
                        filter={column?.filter}
                        format={column?.format}
                        width={'2000'}
                        editable={column?.editable}
                        cells={{ headerCell:IconHeaderCell }}
                      />
                  )
                )
              :
              columns?.columns?.map((column: any, index: any) =>
                columns?.show && (
                  column.field == 'battery' ?
                    <Column              
                      field='battery'
                      title={localizationService.toLanguageString('beacons.battery', 'NOT_FOUND')}
                      editable={false}
                      filterable={true}
                      columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                      className='k-text-center'
                      filter={column?.filter}
                      format={column?.format}
                      sortable={true}
                      cells={{
                          data: CellBatteryComponent,
                          headerCell:IconHeaderCell
                      }}
                    />
                  :
                  <Column
                    key={index}
                    field={column.field}
                    title={column.title}
                    filterable={column?.filterable}
                    columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                    className='k-text-center'
                    cells={{ headerCell:IconHeaderCell }}
                    filter={column?.filter}
                    format={column?.format}
                    editable={column?.editable}
                  />
                )
              )
            }
          </Grid>
        </ExcelExport>
        
        <GridPDFExport ref={_pdfExport} margin="1cm">
          {
            columns?.length > 0 ?
              columns?.map((column: any, index: any) => {
                return (
                  column.field == 'battery' ?
                    <GridColumn              
                      field='battery'
                      title={localizationService.toLanguageString('beacons.battery', 'NOT_FOUND')}
                      editable={false}
                      filterable={true}
                      columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                      className='k-text-center'
                      filter={column?.filter}
                      format={column?.format}
                      sortable={true}
                      cells={{
                          data: CellBatteryComponent,
                          headerCell:IconHeaderCell
                      }}
                    />
                  :
                  <GridColumn
                    key={index}
                    field={column.field}
                    title={column.title}
                    filterable={column?.filterable}
                    columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                    className='k-text-center'
                    cells={{ headerCell:IconHeaderCell }}
                    editable={column?.editable}
                  />
                )
              })
              :
              columns?.columns?.map((column: any, index: any) => {
                return (
                  column.field == 'battery' ?
                    <GridColumn              
                      field='battery'
                      title={localizationService.toLanguageString('beacons.battery', 'NOT_FOUND')}
                      editable={false}
                      filterable={true}
                      columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                      className='k-text-center'
                      filter={column?.filter}
                      format={column?.format}
                      sortable={true}
                      cells={{
                          data: CellBatteryComponent,
                          headerCell:IconHeaderCell
                      }}
                    />
                  :
                  <GridColumn
                    key={index}
                    field={column.field}
                    title={column.title}
                    filterable={column?.filterable}
                    columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                    className='k-text-center'
                    cells={{ headerCell:IconHeaderCell }}
                    editable={column?.editable}
                  />
                )
              })

          }
          <Grid
            data={processedData}
            dataItemKey={"id"}
            //cellRender={CellRender}
            cells={{ data: CellRender}}
            skip={pageIndex.skip}
            take={pageIndex.take}
            total={totalItems}
            reorderable={false}
            filterable={true}
            sortable={true}
            pageable={{ type: 'input', buttonCount: 5, pageSizes: [5, 10, 50, 100, 'All'], info: true }}
            sort={dataState.sort}
            filter={dataState.filter}
            onPageChange={pageChange}
            onColumnReorder={onColumnReorder}
            onColumnResize={onColumnResize}
            onDataStateChange={onDataStateChange}
            scrollable= {'none'}
          >
            <GridToolbar>
              <div>
                <h3>{localizationService.toLanguageString('beacons.title', 'NOT_FOUND')}</h3>
              </div>
              <div style={{ right: '15px', float: 'right', position: 'absolute', display: 'flex', gap: '8px' }}>
                <div>
                  <Button
                    title={localizationService.toLanguageString('save_config', 'NOT_FOUND')}
                    themeColor={'primary'}
                    size="small"
                    svgIcon={saveIcon}
                    onClick={saveStateToLocalStorage}
                  >
                  </Button>
                </div>
                <div>
                  <Button
                    themeColor={'primary'}
                    size="small"
                    svgIcon={uploadIcon}
                    onClick={loadStateFromLocalStorage}
                    title={localizationService.toLanguageString('load_config', 'NOT_FOUND')}
                  >
                  </Button>
                </div>
                <div>
                  <CSVLink data={json2csv(dataState)} separator={","}>
                    <Button
                      themeColor={"primary"}
                      size="small"
                      title={localizationService.toLanguageString('export_to_csv', 'NOT_FOUND')}
                      svgIcon={fileCsvIcon}
                    />
                  </CSVLink>
                </div>
                <div>
                  <Button
                    onClick={pdfExport}
                    themeColor={"primary"}
                    size="small"
                    title={localizationService.toLanguageString('export_to_pdf', 'NOT_FOUND')}
                    svgIcon={filePdfIcon}
                  />
                </div>
                <div>
                  <Button
                    title={localizationService.toLanguageString('export_to_excel', 'NOT_FOUND')}
                    themeColor={"primary"}
                    size="small"
                    svgIcon={fileExcelIcon}
                    onClick={excelExport}
                  />
                </div>
                <ConfiguratorToggleColumnsGrid columns={columns} onChange={onChange} />
              </div>
            </GridToolbar>
            <Column
              cell={(props: any) =>
                <LinkMapCell  {...props} />
              }
              width={75}
              editable={false}
              filterable={false}
            />
            {
              columns.length > 0 ?
                columns?.map((column: any, index: any) =>
                  column.show && (
                    column.field == 'battery' ?
                    <GridColumn              
                      field='battery'
                      title={localizationService.toLanguageString('beacons.battery', 'NOT_FOUND')}
                      editable={false}
                      filterable={true}
                      columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                      className='k-text-center'
                      filter={column?.filter}
                      format={column?.format}
                      sortable={true}
                      cells={{
                          data: CellBatteryComponent,
                          headerCell:IconHeaderCell
                      }}
                    />
                  :
                    <GridColumn
                      key={index}
                      field={column.field}
                      title={column.title}
                      filterable={column?.filterable}
                      columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                      className='k-text-center'
                      cells={{ headerCell:IconHeaderCell }}
                      filter={column?.filter}
                      format={column?.format}
                      editable={column?.editable}
                    />
                  )
                )
              :
              columns?.columns?.map((column: any, index: any) =>
                columns.show && (
                  column.field == 'battery' ?
                    <GridColumn              
                      field='battery'
                      title={localizationService.toLanguageString('beacons.battery', 'NOT_FOUND')}
                      editable={false}
                      filterable={true}
                      columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                      className='k-text-center'
                      filter={column?.filter}
                      format={column?.format}
                      sortable={true}
                      cells={{
                          data: CellBatteryComponent,
                          headerCell:IconHeaderCell
                      }}
                    />
                  :
                  <GridColumn
                    key={index}
                    field={column.field}
                    title={column.title}
                    filterable={column?.filterable}
                    columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                    className='k-text-center'
                    cells={{ headerCell:IconHeaderCell }}
                    filter={column?.filter}
                    format={column?.format}
                    editable={column?.editable}
                  />
                )
              )
            }
          </Grid>
        </GridPDFExport>
    </div>
  );
};